import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=f0596cca"
import script from "./TemplateHeader.vue?vue&type=script&lang=js"
export * from "./TemplateHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports